const import_fields = {
  'last_import_cards.list.text.last_import': 'Dernier import : ',
  'last_import_cards.list.text.last_imports': 'Imports précédents : ',
  'last_import_cards.no_imports': 'Aucun import récent',
  'import_details.title': 'Détails du Relevé d’heures',
  'import.props.status.STATUS_PARSING': "En cours d'importation",
  'import.props.status.STATUS_IN_PROGRESS': 'En cours',
  'import.props.status.STATUS_READY_TO_REVIEW': 'A traiter',
  'import.props.status.STATUS_DONE': 'Terminé',
  'import.props.status.STATUS_FAILED': 'En échec',
  'import.props.status.STATUS_CANCELED': 'Annulé',
  'import.props.status.STATUS_PASSED': 'Passé',
  'import.props.created_at': 'Importé le',
  'import.props.channel_code': 'Client / VMS',
  'import.props.agency': 'Agence',
  'import.props.generic_import': 'Import générique',
  'import.props.client': 'Client',
  'import.props.started_at': 'Période début',
  'import.props.ended_at': 'Période fin',
  'import.props.type': 'Type',
  'import.props.status': 'Status',
  'import.props.stated_in_anael': 'Traité dans anaël',
  'import.props.stated_offtool': 'Traité hors outil',
  'import.props.stated_refused': 'Refusé',
  'import.props.multi_agency': 'Multiples Agences',
  'import.props.type.auto': 'Auto',
  'import.props.type.manual': 'Manuel',
  'import.props.import_type': 'Type d’import',
  'import.props.delete_mapping': 'Supprimer le mapping',
  'import.props.clientSiret': 'Siret du client',
  'import.props.candidate': 'Intérimaire',
  'import.props.contract': 'Contrat',
  'import.props.amount': 'Montant',
  'import.props.week_number': 'Semaine',
  'import.props.start_date': 'Début',
  'import.props.end_date': 'Fin',
  'import.header.card.title.imported_timesheets': "Relevés d'heures importés",
  'import.header.card.title.stated_timesheets': "Relevés d'heures traités",
  'import.header.card.tooltip.imported_timesheets':
    'Un RH est considéré importé, lorsqu’il correspond à un contrat.',
  'import.header.card.tooltip.stated_timesheets':
    'Un RH est considéré traité, lorsqu’il à été intégré dans Anael, traité hors outil ou refusé.',
  'import.header.card.title.client': 'Client/VMS :',
  'import.header.card.title.agency': 'Agence :',
  'import.header.card.title.period': 'Période :',
  'import.header.card.to_verify': 'à vérifier',
  'import.form.message.no_model': 'Aucun modèle disponible',
  'import.form.message.canceled':
    "L'import du fichier RH a été annulé avec succès",
  'import.form.message.failed':
    'Nous avons rencontré une erreur sur votre fichier, veuillez réessayer de l’importer',
};

const timesheet = {
  'timesheet.dashboard.switchCg':
    'voir tous les Relevés d’heures de mon centre de gestion',
  'timesheet.dashboard.switcRespCg': 'voir tous les Relevés d’heures',
  'timesheet.action.offTool.label': 'Traiter hors outil',
  'timesheet.action.update.timesheet': 'Relancer matching contrat',
  'timesheet.form.logic.isEmpty': 'Le champ Logique est obligatoire',
  'timesheet.form.addLine.categIsEmpty':
    'La catégorie est manquante lors de l’ajout de ligne dans le financier',
  'timesheet.list.title': 'Détails des derniers imports',
  'timesheet.props.candidate': 'Intérimaire',
  'timesheet.props.agency': 'Agence',
  'timesheet.props.contract': 'Contrat',
  'timesheet.props.identifier': 'Id source',
  'timesheet.props.totalQuantity': 'Total Heures payées',
  'timesheet.props.totalBilled': 'Total Facturé',
  'timesheet.props.client': 'Client',
  'timesheet.props.weekNumber': 'Semaine',
  'timesheet.props.startDate': 'Début',
  'timesheet.props.importDate': 'Import le',
  'timesheet.props.endDate': 'Fin',
  'timesheet.props.actions': 'Actions',
  'timesheet.props.libelleClient': 'Désignation Client',
  'timesheet.props.anaelCategoryCode': 'Rub. Anaël',
  'timesheet.props.anaelCategoryLabel': 'Libellé Rubrique Anaël',
  'timesheet.props.category': 'Rubrique',
  'timesheet.props.firstName': 'Prénom',
  'timesheet.props.lastName': 'Nom',
  'timesheet.props.truncatedPart': 'S',
  'timesheet.props.day.0': 'Lun.',
  'timesheet.props.day.1': 'Mar.',
  'timesheet.props.day.2': 'Mer.',
  'timesheet.props.day.3': 'Jeu.',
  'timesheet.props.day.4': 'Ven.',
  'timesheet.props.day.5': 'Sam.',
  'timesheet.props.day.6': 'Dim.',
  'timesheet.props.total': 'Total',
  'timesheet.props.ratePaid': 'Taux Payé',
  'timesheet.props.coefficient': 'Coefficient',
  'timesheet.props.code': 'Code',
  'timesheet.props.ratePaid.rate': 'Taux',
  'timesheet.props.ratePaid.paid': 'Payé',
  'timesheet.props.coeff': 'Coeff.',
  'timesheet.props.workTime.day': 'Jour',
  'timesheet.props.workTime.night': 'Nuit',
  'timesheet.props.workTime.dayAndNight': 'Jour et/ou nuit',
  'timesheet.props.workTime.modulation': 'Jours en modulation',
  'timesheet.props.week': 'Semaine',
  'timesheet.props.base': 'Base',
  'timesheet.props.basePaid': 'Base payée',
  'timesheet.props.baseBilled': 'Base facturée',
  'timesheet.props.amount': 'Montant',
  'timesheet.props.logic': 'Logique',
  'timesheet.props.specificDesignation': 'Désignation spécifique',
  'timesheet.props.period': 'Période',
  'timesheet.props.statedAt': 'Date de traitement',
  'timesheet.props.statedBy': 'Traité par',
  'timesheet.props.status': 'Statut',
  'timesheet.props.status.VALIDATED': 'Validé',
  'timesheet.props.status.AUTO_VALIDATED': 'Validé par import',
  'timesheet.props.status.CLEANED': 'Nettoyé automatiquement',
  'timesheet.props.status.PENDING_REVIEW': 'À vérifier',
  'timesheet.props.status.OFF_TOOL': 'Hors Outil',
  'timesheet.props.status.PENDING': 'À traiter',
  'timesheet.props.status.MODIFIED_BY_CLIENT': 'Modifié par le client',
  'timesheet.props.status.BILLED': 'Facturé',
  'timesheet.props.clientCoeff': 'Coeff. Client',
  'timesheet.props.contractCoeff': 'Coeff. Contrat',
  'timesheet.props.tooltip.categoryNotInFinancial':
    'Rubrique non prévue dans le financier du contrat sur Anaël',
  'timesheet.props.tooltip.financialNotInTimesheet':
    'Rubrique prévue dans le financier du contrat sur Anaël, mais non présente sur le relevé d’heures saisi par le client',
  'timesheet.props.tooltip.copyLine': 'Matcher aux données client',
  'timesheet.props.tooltip.cancelCopyLine': 'Annuler le matching',
  'timesheet.props.paid': 'Payé',
  'timesheet.props.billed': 'Facturé',
  'timesheet.props.placeholder.categoryCode': 'Rub.',
  'timesheet.props.placeholder.categoryLabel': 'Libellé',
  'timesheet.props.importDate.format.days': 'DD/MM/YYYY',
  'timesheet.props.importDate.format.hours': 'HH[h]mm',
  'timesheet.props.totalPaid': 'Total payé',
  'timesheet.props.rateBilled': 'Taux facturé',

  'timesheet.actions.addNewDesignation': 'Ajouter "{{-code}}"',
  'timesheet.actions.clearBoth': 'Effacer',
  'timesheet.warnings.logicCodeAlreadyMapped':
    'Ce code logique est déjà rattaché à une autre désignation spécifique : "{{designation}}"',
  'timesheet.warnings.designationWithoutLogicCode':
    "La désignation spécifique ne sera pas envoyée à Anaël si le code logique n'est pas renseigné. Vous pouvez aussi supprimer la désignation spécifique.",
  'timesheet.info.newDesignationMapping':
    "Vous créez un nouveau combo désignation spécifique - code logique. Ce mapping sera créé dans Anaël lors de l'intégration.",
  'timesheet.info.logicCodeDisabled':
    'Si vous souhaitez afficher et renseigner un code logique, merci de réactiver la fonctionnalité dans votre référentiel.',

  'timesheet.modal.sendToAnael.title': 'Intégrer dans Anaël',
  'timesheet.modal.sendToAnael.categoryCodesMissingInSlips':
    'Certaines rubriques sont manquantes dans les lignes de financier. Veuillez recalculer la ventilation en cliquant sur le bouton continuer.',
  'timesheet.modal.sendToAnael.platformLogicCodeLengthExceeded':
    'Le code logique ne doit pas excéder plus de 6 caractères.',
  'timesheet.modal.sendToAnael.missingContract':
    'Le contrat est manquant. Veuillez sélectionner un contrat et recalculer la ventilation en cliquant sur le bouton continuer.',
  'timesheet.modal.refuse.title': 'Refuser',
  'timesheet.modal.refuse.message': 'Je souhaite refuser ce relevé d’heures',
  'timesheet.modal.refuse.toast.success':
    'Le relevé d’heures a bien été refusé',
  'timesheet.modal.offTool.title': 'Traiter hors outil',
  'timesheet.modal.offTool.message':
    'Je souhaite traiter ce relevé d’heures directement sur Anaël :',
  'timesheet.modal.offTool.toast.success':
    'Le relevé d’heures de {{name}} a bien été traité hors outil',
  'timesheet.modal.offToolMany.toast.success_one':
    'Le relevé d’heures a bien été traité hors outil',
  'timesheet.modal.offToolMany.toast.success_other':
    'Les {{count}} relevés d’heures ont bien été traités hors outil',
  'timesheet.modal.offToolMany.toast.error_other':
    "Le relevé d’heures n'a pas pu être traité hors outil",
  'timesheet.modal.offToolMany.toast.error_one':
    "Les {{count}} relevés d’heures n'ont pas pu être traités hors outil",
  'timesheet.modal.bulk.offTool.toast.success':
    'Les relevés d’heures ont été traités hors outil',
  'timesheet.modal.zeroTotalBilledOffTool.message':
    "Je souhaite traiter ces {{number}} relevés d'heures directement dans Anaël",
  'timesheet.modal.zeroTotalBilledOffTool.toast.success':
    "Les {{number}} relevés d'heures à 0€ ont bien été traités hors outil",
  'timesheet.modal.common.info':
    'Lorsque vous cliquez sur “Confirmer”, le relevé d’heures n’apparaitra plus sur le tableau de bord',
  'timesheet.modal.offTool.info':
    'Lorsque vous cliquez sur “Traiter hors outil”, le relevé d’heures n’apparaitra plus sur le tableau de bord',
  'timesheet.modal.total.different.title': 'Intégrer dans Anaël',
  'timesheet.modal.total.different.subtitle':
    'Je souhaite intégrer le relevé d’heures dans Anaël',
  'timesheet.modal.total.different.message':
    'Le montant facturé à insérer dans Anaël ne correspond pas au montant facturé client.',
  'timesheet.modal.addTimesheet.success':
    'Le relevé d’heures de {{name}} a bien été intégré dans Anaël',
  'timesheet.modal.timesheet.exists.check.message.part_1':
    'Nous sommmes en train de ',
  'timesheet.modal.timesheet.exists.check.message.part_2': 'vérifier',
  'timesheet.modal.timesheet.exists.check.message.part_3':
    ' si un relevé d’heures n’existe pas déjà dans Anaël.',
  'timesheet.modal.timesheet.exists.message_1':
    'Un relevé d’heures a été trouvé dans Anaël.',
  'timesheet.modal.timesheet.exists.message_2.part_1':
    'Je souhaite finaliser l’intégration dans Anaël en ',
  'timesheet.modal.timesheet.exists.message_2.part_2': 'écrasant ',
  'timesheet.modal.timesheet.exists.message_2.part_3': 'les données du ',
  'timesheet.modal.timesheet.exists.message_2.part_4':
    'relevé d’heures déjà existantes ',
  'timesheet.modal.timesheet.exists.message_2.part_5':
    'dans Anaël avec ce relevé d’heures.',
  'timesheet.modal.timesheet.motive_end.closed.title':
    'Attention le contrat lié à ce relevé d’heures est en fermeture',
  'timesheet.modal.timesheet.motive_end.closed.message':
    "Vous pouvez tout de même choisir de <bold>poursuivre l'intégration dans anaël</bold> si vous le souhaitez.",
  'timesheet.modal.timesheet.motive_end.closed.submit': 'Intégrer dans Anaël',
  'timesheet.modal.timesheet.motive_end.cancelled.title':
    "Impossible d'intégrer ce relevé d'heures dans Anaël",
  'timesheet.modal.timesheet.motive_end.cancelled.message':
    "Le contrat lié à ce relevé d'heure à été <bold>annulé,</bold> vous ne pouvez plus <bold>l'intégrer dans anaël.</bold>",
  'timesheet.modal.unmatchedCategories.title': 'Associations manquantes',
  'timesheet.modal.unmatchedCategories.message_one':
    "{{count}} rubrique n'est pas encore associée",
  'timesheet.modal.unmatchedCategories.message_other':
    '{{count}} rubriques ne sont pas encore associées',
  'timesheet.modal.unmatchedCategories.description':
    'Pour pouvoir traiter le RH veuillez mettre à jour le référentiel du client',
  'timesheet.modal.unmatchedCategories.associate': 'Associer les rubriques',
  'timesheet.modal.timesheet.not.exists.message_1':
    'Aucun relevé d’heures n’a été trouvé dans Anaël.',
  'timesheet.modal.timesheet.not.exists.message_2.part_1': 'Je souhaite ',
  'timesheet.modal.timesheet.not.exists.message_2.part_2':
    'finaliser l’intégration',
  'timesheet.modal.timesheet.not.exists.message_2.part_3': ' dans Anaël.',
  'timesheet.modal.timesheet.billedOrPaid.message_1.part_1':
    'Le relevé d’heures a déjà été ',
  'timesheet.modal.timesheet.billedOrPaid.message_1.part_2': 'facturé ou payé ',
  'timesheet.modal.timesheet.billedOrPaid.message_1.part_3': 'et ',
  'timesheet.modal.timesheet.billedOrPaid.message_1.part_4':
    'ne peut plus être transféré ',
  'timesheet.modal.timesheet.billedOrPaid.message_1.part_5': 'à Anaël.',
  'timesheet.modal.timesheet.validate.info.message':
    'Lorsque vous cliquez sur “Confirmer”, le relevé d’heures n’apparaitra plus sur le tableau de bord.',
  'timesheet.modal.timesheet.validate.errorParams.message':
    'Des paramètres obligatoires manquent pour faire l’appel à l’API Anaël - contactez le support si l’erreur persiste.',
  'timesheet.modal.timesheet.validate.errorApi.message':
    'Une Erreur API Anaël est survenue.',
  'timesheet.modal.contract.validate.title': 'Valider le contrat',
  'timesheet.modal.contract.validate.message':
    'Je souhaite sélectionner le contrat numéro ',
  'timesheet.modal.contract.validate.warning':
    'Une fois le contrat confirmé, vous n’aurez plus accès aux autres contrats proposés',
  'timesheet.modal.timesheet.validate.noDataApi.message':
    'L’API Anaël n’a pas renvoyé de données.',
  'timesheet.modal.timesheet.validate.toast.success':
    'Matching contrat confirmé',
  'timesheet.modal.timesheet.validate.toast.error.noChosenContract':
    'Aucun contrat n’a été choisi',
  'timesheet.alert.no-client-informations.title':
    'Informations client non disponibles',
  'timesheet.alert.no-client-informations.message':
    'Nous ne disposons pas des informations concernant le montant client et ne pouvons donc pas les afficher dans ce détail.',
  'timesheet.alert.round.billed': 'Arrondi facturation',
  'timesheet.toast.contractAttached': 'Le contrat a bien été rattaché.',
  'timesheet.toast.bindContract.error':
    'Une erreur est survenue lors du rattachement du contrat.',
  'timesheet.toast.contractDetached.title': 'Le contrat a bien été détaché.',
  'timesheet.toast.contractDetached.subtitle':
    'Vous pouvez rattacher un nouveau contrat.',
  'timesheet.toast.contractUpdated': 'Le contrat a bien été mis à jour',
  'timesheet.toast.contractNotUpdated': "Le contrat n'a pas été mis à jour",
  'timesheet.toast.matchingContractLaunched': 'Le matching a bien été relancé',
  'timesheet.toast.updateAnaelCategoryError':
    'Cette rubrique a déjà été associée',
  'timesheet.truncatedWeek.period.billed': 'Période déjà facturée ({{month}})',
  'timesheet.truncatedWeek.period.toBill': 'Période à facturer ({{month}})',
  'timesheet.truncatedWeek.chip.billed': 'Déjà facturée',
  'timesheet.truncatedWeek.chip.toProcess': 'À traiter',
  'timesheet.truncatedWeek.chip.toBill': 'À facturer - Modifiable',
};

const historyActions = {
  'historyActions.main.title': 'Historique des actions',
  'historyActions.sort.add': 'Ajouter un tri',
  'historyActions.filters.title': 'Filtres',
  'historyActions.filters.status': 'Statut',
  'historyActions.filters.agency': 'Code agence',
  'historyActions.filters.client': 'Client',
  'historyActions.filters.candidate': 'Intérimaire',
  'historyActions.filters.button': 'Rechercher',
  'historyActions.filters.statedAt': 'Date de traitement',
  'historyActions.filters.weekNumber': 'Semaine',
  'historyActions.filters.treatedRange':
    'Traité du {{- from, DD/MM }} au {{- to, DD/MM }}',
  'historyActions.noSnapshot.error':
    "L'historique n'est pas disponible pour ce relevé d'heures",
};

const advanceRequest = {
  'advance.period.add.range.type_paie':
    'Du {{- from, DD/MM/YYYY à HH:mm }} au {{- to, DD/MM/YYYY à HH:mm }}',
  'advance.period.filters.title': 'Filtrer',
  'advance.period.filters.hide_previous': 'Masquer périodes passées',
  'advance.period.filters.period_type': 'Type d’indisponibilité',
  'advance.period.filters.period_type.pay_type': 'Gestion des paies',
  'advance.period.filters.period_type.advance_treatment_type':
    'Gestion des acomptes',
};

const activityLog = {
  'activityLog.title': 'Historique',
  'activityLog.tooltip': "Voir l'historique des modifications",
  'activityLog.createdAt': 'RH créé le {{- date}}',
  'activityLog.lastSentAnaelAt': 'Dernier envoi Anaël le {{- date}}',
  'activityLog.dateTime': 'Le {{- date}} à {{- time}}',
  'activityLog.empty': 'Aucun historique disponible',
  'activityLog.event.send_to_anael.success': 'Envoyé sur Anaël',
  'activityLog.event.send_to_anael.failed': "Échec de l'envoi vers Anaël",
  'activityLog.event.timesheet.created': 'RH créé',
  'activityLog.event.timesheet.updated': 'RH mise à jour',
  'activityLog.event.timesheet.reset': 'RH réinitialisé',
  'activityLog.event.timesheet.reconciliation': 'Rapprochement effectué',
  'activityLog.event.timesheet.billed': 'RH facturé',
  'activityLog.event.timesheet.off_tool': 'Traité hors outil',
  'activityLog.event.timesheet.auto_validated': 'Validé automatiquement',
  'activityLog.event.timesheet.validated': 'RH validé',
  'activityLog.event.timesheet.processor.anael_integration':
    'Application des règles financières',
  'activityLog.event.timesheet.processor.client_enrichment':
    'Enrichissement client',
  'activityLog.event.timesheet.slip.attached': 'Bordereau attaché',
  'activityLog.event.timesheet.slip.removed': 'Bordereau retiré',
  'activityLog.event.timesheet.slip.created': 'Bordereau créé',
  'activityLog.event.timesheet.slip.updated': 'Bordereau mis à jour',
  'activityLog.event.timesheet.slip.deleted': 'Bordereau supprimé',
  'activityLog.event.timesheet.associated_to_contract': 'Associé au contrat',
  'activityLog.event.timesheet.contract.detached': 'Contrat détaché',
  'activityLog.event.timesheet.import.no_changes': 'Import sans changement',
  'activityLog.event.timesheet.import.changes_detected':
    "Changements détectés à l'import",
  'activityLog.event.timesheet.day_entry.changed':
    'Saisie journalière modifiée',
  'activityLog.event.unknown': 'Événement inconnu',
  'activityLog.description.contract': 'Contrat {{- code}}',
  'activityLog.description.agency': 'Agence {{- code}}',
  'activityLog.description.week': 'Semaine {{week}}',
  'activityLog.description.platformId': 'ID plateforme : {{- id}}',
  'activityLog.description.totalBilled': 'Montant facturé : {{amount}}€',
  'activityLog.description.commentaryUpdated': 'Commentaire mis à jour',
  'activityLog.description.contractAttached': 'Contrat n°{{- code}}',
  'activityLog.description.contractDetached': 'Contrat n°{{- code}} détaché',
  'activityLog.description.rulesApplied': '{{count}} règle(s) appliquée(s)',
  'activityLog.description.fieldsChanged': 'Champs modifiés : {{- fields}}',
  'activityLog.description.slipCategory': 'Rubrique {{- code}} {{- label}}',
  'activityLog.description.slipRemoved': 'Rubrique {{- code}} supprimée',
  'activityLog.description.dayEntryDate': 'Date : {{- date}}',
  'activityLog.description.quantityChanged': 'Quantité : {{old}}h → {{new}}h',
  'activityLog.description.slipsAdded': '{{count}} rubrique(s) ajoutée(s)',
  'activityLog.description.slipsModified': '{{count}} rubrique(s) modifiée(s)',

  'activityLog.details.slipsAdded': 'Rubriques ajoutées',
  'activityLog.details.slipsModified': 'Rubriques modifiées',
  'activityLog.details.rulesApplied': 'Détail des règles',

  'activityLog.ruleAction.slipDataCopied': 'Données copiées du contrat',
  'activityLog.ruleAction.slipsRemovedNoCategory':
    'Rubriques sans catégorie supprimées',
  'activityLog.ruleAction.nonWorkingHoursDeducted':
    'Heures non travaillées déduites',
  'activityLog.ruleAction.surchargeRatesUpdated':
    'Taux de majoration mis à jour',
  'activityLog.ruleAction.incidentSlipsAdded': 'Rubriques incident ajoutées',
  'activityLog.ruleAction.sundayHoursRedistributed':
    'Heures dimanche redistribuées',
  'activityLog.ruleAction.lunchCategoriesProcessed':
    'Catégories repas traitées',
  'activityLog.ruleAction.roundingSlipAdded': 'Rubrique arrondi ajoutée',
  'activityLog.ruleAction.dressingBonusDispatched': 'Prime habillage ventilée',
  'activityLog.ruleAction.ratioApplied': 'Ratio appliqué',
  'activityLog.ruleAction.daysDispatchedTruncatedWeek':
    'Jours ventilés semaine tronquée',
  'activityLog.ruleAction.daysFilledForWeek': 'Jours remplis pour la semaine',
  'activityLog.ruleAction.hoursMovedToContractStart':
    'Heures déplacées au début du contrat',
  'activityLog.ruleAction.anaelCategoriesMatched': 'Catégories Anaël matchées',
  'activityLog.ruleAction.suggestionCategoriesAdded':
    'Suggestions de catégories ajoutées',
  'activityLog.ruleAction.category90Added': 'Catégorie 90 ajoutée',
  'activityLog.ruleAction.integrationValidated': 'Intégration validée',
  'activityLog.ruleAction.emptyVentilationsRemoved':
    'Ventilations vides supprimées',
  'activityLog.ruleAction.surchargeCategoriesSwapped':
    'Catégories majoration permutées',
  'activityLog.ruleAction.billedHoursShiftedToPaid':
    'Heures facturées transférées en payées',
  'activityLog.ruleAction.contractLunchCategoryApplied':
    'Catégorie repas contrat appliquée',
  'activityLog.ruleAction.unknown': 'Action',
};

const delegations = {
  'delegations.main.title': 'Gestion des délégations',
  'delegations.subtitle': 'Historique des délégations',
  'delegations.dashboard.delegateSource': 'Délégataire',
  'delegations.dashboard.delegateTarget': 'Délégué',
  'delegations.dashboard.period': 'Période',
  'delegations.dashboard.agencies': 'Agences',
  'delegations.dashboard.reason': 'Motif',
  'delegations.dashboard.status': 'Statut',
  'delegations.dashboard.action': 'Action',
  'delegations.dashboard.empty': 'Aucune délégation active',
  'delegations.dashboard.status.coming': 'À venir',
  'delegations.dashboard.status.active': 'En cours',
  'delegations.button.create': 'Créer une délégation',
  'delegations.create.title': 'Création d’une délégation',
  'delegations.create.delegateSource.subtitle': 'Délégataire',
  'delegations.create.delegateTarget.subtitle': 'Délégué',
  'delegations.create.label.lastname': 'Nom',
  'delegations.create.label.firstname': 'Prénom',
  'delegations.create.label.profile': 'Profil :',
  'delegations.create.delegation.subtitle': 'Délégation',
  'delegations.create.delegation.label.period': 'Période :',
  'delegations.create.delegation.label.agency': 'Agence(s) :',
  'delegations.create.delegation.label.reason': 'Motif :',
  'delegations.create.delegation.placeholder.reason': 'Motif de la délégation',
  'delegations.create.delegation.noOptions.agencies':
    'Aucune agence disponible',
  'delegations.update.title': 'Modification d’une délégation',
  'delegations.modal.addDelegation.success':
    'Votre délégation a bien été créée',
  'delegations.modal.updateDelegation.success':
    'Votre délégation a bien été modifiée',
  'delegations.modal.removeDelegation.title': 'Supprimer une délégation',
  'delegations.modal.removeDelegation.message':
    'Lorsque vous cliquez sur "Confirmer", la délégation sera définitivement supprimée.',
  'delegations.modal.removeDelegation.success':
    'La délégation a bien été supprimée',
  'delegations.create.delegation.noOptions.delegateTarget':
    'Aucune personne trouvée à qui déléguer',
};

const dashboard = {
  'dashboard.filters.client': 'Client',
  'dashboard.filters.candidate': 'Intérimaire',
  'dashboard.filters.agency': 'Agence',
  'dashboard.filters.contract': 'Contrat',
  'dashboard.filters.period': 'Période',
  'dashboard.filters.weekNumber': 'Semaine',
  'dashboard.action.processRHAll': 'Traiter les RH',
  'dashboard.action.processRH_one': 'Traiter le RH',
  'dashboard.action.processRH_other': 'Traiter les {{count}} RH',
  'dashboard.selectedTimesheets_one': '{{count}} RH sélectionné',
  'dashboard.selectedTimesheets_other': '{{count}} RH sélectionnés',
  'dashboard.timesheetGroups': '{{value}} groupes de RH',
};

export default {
  ...import_fields,
  ...timesheet,
  ...historyActions,
  ...advanceRequest,
  ...activityLog,
  ...delegations,
  ...dashboard,
};
